import { useState } from 'react';
import { callApi } from '../services/apiService';
import { responseHandler } from '../handler/responseHandler';

export const RecruiterApi = {


  getJobsList: async (params = {}) => {
    const response = callApi({
      method: 'POST',
      endpoint: 'jobs',
      params: params,
      isFile: false
    });
    return responseHandler(response);
  },
  getJobsListOnStatus: async (params = {}, options = {}) => {
    console.log(params)
    const response = callApi({
      method: 'POST',
      endpoint: 'jobs_on_status',
      params: params,
      isFile: false,
      signal: options?.signal || null
    });
    return responseHandler(response);
  },
  getJobDetails: async (params = {}) => {
    const response = callApi({
      method: 'POST',
      endpoint: 'job_description',
      params: params,
      isFile: false
    });
    return responseHandler(response);
  },
  getJobDescription: async (params = {}, options = {}) => {
    const response = callApi({
      method: 'POST',
      endpoint: 'generate-job-template',
      params: params,
      isFile: false,
      signal: options?.signal || null
    });
    return responseHandler(response);
  },
  getCandidates: async (params = {}, options = {}) => {
    const response = callApi({
      method: 'POST',
      endpoint: 'candidates',
      params: params,
      isFile: false,
      signal: options?.signal || null
    });
    return responseHandler(response);
  },
  searchCandidates: async (params = {}, options = {}) => {
    const response = callApi({
      method: 'POST',
      endpoint: 'candidate_search',
      params: params,
      isFile: false,
      signal: options?.signal || null
    });
    return responseHandler(response);
  },
  getJobsBySearch: async (params = {}, options = {}) => {
    const response = callApi({
      method: 'POST',
      endpoint: 'jobdescription_search',
      params: params,
      isFile: false,
      signal: options?.signal || null
    });
    return responseHandler(response);
  },
  registerRecruiter: async (params = {}, options = {}) => {
    const response = callApi({
      method: 'POST',
      endpoint: 'signup',
      params: params,
      isFile: false,
      signal: options?.signal || null
    });
    return responseHandler(response);
  },

  fetch_leaderboard_table_data: async (params = {}, options = {}) => {
    const response = callApi({
      method: 'POST',
      endpoint: 'leaderboard_table_data',
      params: params,
      isFile: false,
      signal: options?.signal || null
    });
    return responseHandler(response);
  },

  getFormattedResumePreview: async (params = {}, options = {}) => {
    const response = callApi({
      method: 'POST',
      endpoint: 'formatted_resume_preview',
      params: params,
      isFile: false,
      signal: options?.signal || null
    });
    return responseHandler(response);
  },

  getResumePreview: async (params = {}, options = {}) => {
    const response = callApi({
      method: 'POST',
      endpoint: 'resume_preview',
      params: params,
      isFile: false,
      signal: options?.signal || null
    });
    return responseHandler(response);
  },
  getSmartMatchCandidates: async (params = {}, options = {}) => {
    const response = callApi({
      method: 'POST',
      endpoint: 'candidate_shortlist',
      params: params,
      isFile: false,
      signal: options?.signal || null
    });
    return responseHandler(response);
  },
  getJobApplicants: async (params = {}, options = {}) => {
    const response = callApi({
      method: 'POST',
      endpoint: 'getApplicantsByJobId',
      params: params,
      isFile: false,
      signal: options?.signal || null
    });
    return responseHandler(response);
  },
  getCandidateInsights: async (params = {}, options = {}) => {
    const response = callApi({
      method: 'POST',
      endpoint: '_jd_candidate_pre_screening',
      params: params,
      isFile: false,
      signal: options?.signal || null
    });
    return responseHandler(response);
  },
  getJdAttachment: async (params = {}, options = {}) => {
    const response = callApi({
      method: 'POST',
      endpoint: 'job_sharepoint_view',
      params: params,
      isFile: false,
      signal: options?.signal || null
    });
    return responseHandler(response);
  },

  submitToAM: async (params = {}) => {
    const response = callApi({
      method: 'POST',
      endpoint: 'candidate_submit_to_am',
      params: params,
      isFile: false
    });
    return responseHandler(response);
  },

  saveComment: async (params = {}) => {
    const response = callApi({
      method: 'POST',
      endpoint: 'candidate/comment',
      params: params,
      isFile: false
    });
    return responseHandler(response);
  },

  getComment: async (params = {}) => {
    const response = callApi({
      method: 'POST',
      endpoint: 'candidate/get_comment',
      params: params,
      isFile: false
    });
    return responseHandler(response);
  },
  viewApplicantCV: async (params = {}) => {
    const response = callApi({
      method: 'POST',
      endpoint: 'get_sharepoint_file_url',
      params: params,
      isFile: false
    });
    return responseHandler(response);
  },
  formattedCV: async (params = {}) => {
    const response = callApi({
      method: 'POST',
      endpoint: 'create_resume_template',
      params: params,
      isFile: false
    });
    return responseHandler(response);
  },

  bookmarkCandidate: async (params = {}) => {
    const response = callApi({
      method: 'POST',
      endpoint: '_jd_candidate_tag',
      params: params,
      isFile: false
    });
    return responseHandler(response);
  },

  candidatesViewed: async (params = {}) => {
    const response = callApi({
      method: 'POST',
      endpoint: 'candidates_viewed',
      params: params,
      isFile: false
    });
    return responseHandler(response);
  },

  candidatesTagged: async (params = {}) => {
    const response = callApi({
      method: 'POST',
      endpoint: 'candidates_tagged',
      params: params,
      isFile: false
    });
    return responseHandler(response);
  },

  sendMail: async (params = {}) => {
    const response = callApi({
      method: 'POST',
      endpoint: 'send_mail_to_candidates',
      params: params,
      isFile: false
    });
    return responseHandler(response);
  },


  sendSearchMail: async (params = {}) => {
    const response = callApi({
      method: 'POST',
      endpoint: 'candidates_send_mail',
      params: params,
      isFile: false
    });
    return responseHandler(response);
  },

  validate_and_save_jd: async (params = {}) => {
    const response = callApi({
      method: 'POST',
      endpoint: 'validate_and_save_jd',
      params: params,
      isFile: false
    });
    return responseHandler(response);
  },
  edit_job_description: async (params = {}) => {
    const response = callApi({
      method: 'POST',
      endpoint: 'edit_job_description',
      params: params,
      isFile: false
    });
    return responseHandler(response);
  },
    ai_assist_save_jd: async (params = {}) => {
    const response = callApi({
      method: 'POST',
      endpoint: 'enrich_jd',
      params: params,
      isFile: false
    });
    return responseHandler(response);
  },
    enhance_job_description: async (params = {}) => {
    const response = callApi({
      method: 'POST',
      endpoint: 'enhance_job_description',
      params: params,
      isFile: false
    });
    return responseHandler(response);
  },
  validatePromptSearch: async (params = {}) => {
    const response = callApi({
      method: 'POST',
      endpoint: 'search_job_validation',
      params: params,
      isFile: false
    });
    return responseHandler(response);
  },
  getResumeStatus: async (params = {}) => {
    const response = callApi({
      method: 'POST',
      endpoint: 'resume_validate',

      params: params,
      isFile: false
    });
    return responseHandler(response);
  },
  updateResumeStatusBulk: async (params = {}) => {
    const response = callApi({
      method: 'POST',
      endpoint: 'update_resume_status',
      params: params,
      isFile: false
    });
    return responseHandler(response);
  },

  postJobBroadbean: async (params = {}) => {
    const response = callApi({
      method: 'POST',
      endpoint: 'post_job_broadbean',
      params: params,
      isFile: false,
      broadBean: true
    });
    return responseHandler(response);
  },

  getBroadbeanConfig: async () => {
    const response = callApi({
      method: 'GET',
      endpoint: 'broadbean_config',
      params: {},
      isFile: false,
    });
    return responseHandler(response);
  },

  candidatesApplied: async (params = {}) => {
    const response = callApi({
      method: 'GET',
      endpoint: 'fetch_applied_candidates',
      params: params.payload,
      isFile: false
    });
    return responseHandler(response);
  },

  fetchKPIs: async (params = {}) => {
    const response = callApi({
      method: 'POST',
      endpoint: 'fetch_recruiter_performance',
      params: params,
      isFile: false
    });
    return responseHandler(response);
  },

  fetchLeaderboard: async (params = {}) => {
    const response = callApi({
      method: 'POST',
      endpoint: 'fetch_score_of_recruiters',
      params: params,
      isFile: false
    });
    return responseHandler(response);
  },

  fetchPerformanceGraph: async (params = {}) => {
    console.log(params)
    const response = callApi({
      method: 'POST',
      endpoint: 'fetch_graph_score',
      params: params,
      isFile: false
    });
    console.log(response)
    return responseHandler(response);
  },
  userRoleManagement: async (params = {}) => {
    const response = callApi({
      method: 'POST',
      endpoint: 'users_with_roles',
      params: params,
      isFile: false
    });
    return responseHandler(response);
  },
  addUser: async (params = {}) => {
    const response = callApi({
      method: 'POST',
      endpoint: 'create_user',
      params: params,
      isFile: false
    });
    return responseHandler(response);
  },
  editUser: async (params = {}) => {
    const response = callApi({
      method: 'POST',
      endpoint: 'edit_user',
      params: params,
      isFile: false
    });
    return responseHandler(response);
  },
  getAllRoles: async (params = {}) => {
    const response = callApi({
      method: 'POST',
      endpoint: 'get_all_roles',
      params: params,
      isFile: false
    });
    return responseHandler(response);
  },
  addBroadBeanUser: async (params = {}) => {
    const response = callApi({
      method: 'POST',
      endpoint: 'add_broadbean_user',
      params: params,
      isFile: false
    });
    return responseHandler(response);
  },
  updateUserStatus: async (params = {}) => {
    const response = callApi({
      method: 'POST',
      endpoint: 'update_user_status',
      params: params,
      isFile: false
    });
    return responseHandler(response);
  },
  addRole: async (params = {}) => {
    const response = callApi({
      method: 'POST',
      endpoint: 'create_role',
      params: params,
      isFile: false
    });
    return responseHandler(response);
  },
  sendWhatsappMsg: async (params = {}) => {
    const response = callApi({
      method: 'POST',
      endpoint: '_send_whatsapp_request',
      params: params,
      isFile: false,
      broadBean: true
    });
    return responseHandler(response);
  },
  getCandidateWhatsAppConversations: async (candidateId) => {
    const response = callApi({
      method: 'GET',
      endpoint: `conversations/${candidateId}`,
      params: {},
      isFile: false,
      broadBean: true
    });
    return responseHandler(response);
  },
  deleteRole: async (params = {}) => {
    const response = callApi({
      method: 'POST',
      endpoint: 'delete_role',
      params: params,
      isFile: false
    });
    return responseHandler(response);
  },
  getJobStatus: async (params = {}) => {
    const response = callApi({
      method: 'POST',
      endpoint: 'job_openings',
      params: params,
      isFile: false
    });
    return responseHandler(response);
  },
  editComment: async (params = {}) => {
    const response = callApi({
      method: 'POST',
      endpoint: 'candidate/edit_comment',
      params: params,
      isFile: false
    });
    return responseHandler(response);
  },
  deleteComment: async (params = {}) => {
    const response = callApi({
      method: 'POST',
      endpoint: 'candidate/delete_comment',
      params: params,
      isFile: false
    });
    return responseHandler(response);
  },
  getContactedByMe: async (params = {}) => {
    const response = callApi({
      method: 'POST',
      endpoint: 'candidates_contacted_by_me',
      params: params,
      isFile: false
    });
    return responseHandler(response);
  },
  getPlacedCandidates: async (params = {}) => {
    const response = callApi({
      method: 'POST',
      endpoint: 'placed_candidates_pending_feedback',
      params: params,
      isFile: false
    });
    return responseHandler(response);
  },
  sendFeedBackForm: async (params = {}) => {
    const response = callApi({
      method: 'POST',
      endpoint: 'send_placement_feedback_mail',
      params: params,
      isFile: false
    });
    return responseHandler(response);
  },
    getMphCandidateApplications: async (param) => {
    const response = callApi({
      method: 'GET',
      endpoint: 'get_mph_candidate_applications',
      params: param,
      isFile: false
    });
    return responseHandler(response);
  },
   cancelUpload: async (params = {}) => {
    const response = callApi({
      method: 'POST',
      endpoint: 'resume/cancel',
      params: params,
      isFile: false
    });
    return responseHandler(response);
  },
    check_edit_availability: async (params = {}) => {
    const response = callApi({
      method: 'POST',
      endpoint: 'check_edit_availability',
      params: params,
      isFile: false
    });
    return responseHandler(response);
  } ,
    start_edit_session: async (params = {}) => {
    const response = callApi({
      method: 'POST',
      endpoint: 'start_edit_session',
      params: params,
      isFile: false
    });
    return responseHandler(response);
  },
    end_edit_session: async (params = {}) => {
    const response = callApi({
      method: 'POST',
      endpoint: 'end_edit_session',
      params: params,
      isFile: false
    });
    return responseHandler(response);
  },
   save_enhanced_jd: async (params = {}) => {
    const response = callApi({
      method: 'POST',
      endpoint: 'save_enhanced_jd',
      params: params,
      isFile: false
    });
    return responseHandler(response);
  },
   getCandidateSkillsPoints: async (params = {}) => {
    const response = callApi({
      method: 'POST',
      endpoint: 'generate_candidate_skills_points',
      params: params,
      isFile: false
    });
    return responseHandler(response);
  }
}